import { isNone, isSome, Maybe } from '@crocodille/util';
import cn from 'classnames';

import styles from './info-table.module.scss';

const InfoTable: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles.container}>{children}</div>;
};

export interface InfoTableSectionProps {
  readonly title?: Maybe<string>;
}

export const InfoTableSection: React.FC<
  React.PropsWithChildren<InfoTableSectionProps>
> = ({ title, children }) => {
  return (
    <>
      {isSome(title) ? <hr className={styles.sectionSeparator} /> : null}
      {isSome(title) ? <h2 className={styles.sectionTitle}>{title}</h2> : null}
      <div
        className={cn(styles.sectionContent, {
          [styles.isFullWidth]: isNone(title),
        })}
      >
        {children}
      </div>
    </>
  );
};

export default InfoTable;
